import React, { useState, useEffect } from 'react';
import { client as apollo } from 'cccisd-apollo';
import { NotFound } from 'cccisd-laravel-boilerplate';
import Loader from 'cccisd-loader';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import sessionQuery from '../../queries/sessionQuery.graphql';
import IconWarning from 'cccisd-icons/warning';
import style from './style.css';

const TakeSurvey = props => {
    const { match, errorLayout } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [show404, setShow404] = useState(false);
    const [isClosed, setIsClosed] = useState(false);
    const [deploymentId, setDeploymentId] = useState(null);
    const [deploymentHash, setDeploymentHash] = useState(null);
    const [respondentHash, setRespondentHash] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [lastSession, setLastSession] = useState(false);
    const [pawn, setPawn] = useState(null);

    useEffect(() => {
        evaluateDeployment();
    }, []);

    const evaluateDeployment = async () => {
        const depHash = match.params.deploymentHash;
        const respHash = match.params.respondentHash;
        const sessId = match.params.sessionId;

        if (!depHash || !respHash || !sessId) {
            setShow404(true);
            setIsLoading(false);
            return;
        }

        try {
            const result = await apollo.query({
                query: sessionQuery,
                fetchPolicy: 'network-only',
                variables: {
                    deploymentHash: depHash,
                    respondentHash: respHash,
                },
            });

            if (!result.data.flows.deployment.hash) {
                setShow404(true);
                setIsLoading(false);
                return;
            }

            if (!result.data.flows.deployment.isOpen) {
                setIsClosed(true);
            }

            if (result.data.roles.anyRole?.selectedAssignmentPlan?.session?.opensDaysAgo > 14) {
                setIsClosed(true);
            }

            setDeploymentId(result.data.flows.deployment.deploymentId);
            setDeploymentHash(depHash);
            setRespondentHash(respHash);
            setSessionId(parseInt(sessId, 10));
            setLastSession(
                result.data.roles.anyRole?.selectedAssignmentPlan?.session?.sessionDeploymentInfo
                    ?.lastSessionInDeployment
            );
            setPawn(result.data.roles.anyRole);
        } catch (error) {
            setShow404(true);
        }

        setIsLoading(false);
    };

    if (isLoading) {
        return <Loader loading />;
    }

    if (show404) {
        const ErrorLayout = errorLayout;
        if (errorLayout) {
            return (
                <ErrorLayout>
                    <NotFound />
                </ErrorLayout>
            );
        }
        return <NotFound />;
    }

    const closedMessage =
        'This survey is no longer accepting responses. If you have a more recent survey in your messages, please try that link instead. Thank you!';
    const closedLastSurveyMessage = 'This survey is no longer accepting responses. Thank you!';

    // check if the group has emergencyInfo set
    let emergencyInfo = "If you're experiencing an emergency or crisis, please contact 911 or 988.";
    if (pawn && pawn.parentGroup?.site?.fields?.emergencyInfo) {
        emergencyInfo = pawn.parentGroup.site.fields.emergencyInfo;
    }

    if (isClosed) {
        return (
            <div className={style.body}>
                <div className="alert alert-danger" style={{ textAlign: 'center' }}>
                    <div>
                        <IconWarning spaceRight />
                        {lastSession ? closedLastSurveyMessage : closedMessage}
                    </div>
                    <div style={{ marginTop: '10px' }}>{emergencyInfo}</div>
                </div>
            </div>
        );
    }

    return (
        <div className={style.fixContainer}>
            <DeploymentPlayer
                {...props}
                deploymentId={deploymentId}
                deploymentHash={deploymentHash}
                respondentHash={respondentHash}
                pawnHash={pawn?.pawn?.pawnHash}
                pawnId={pawn?.pawn?.pawnId}
                sessionId={sessionId}
                flowProps={{ variables: { emergencyInfo } }}
            />
        </div>
    );
};

export default TakeSurvey;
